import React from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiCheck} = FiIcons;

const Hero = () => {
  return (
    <section className="pt-24 pb-16 md:pt-32 md:pb-24 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto text-center">
      <motion.div
        initial={{opacity: 0, y: 20}}
        animate={{opacity: 1, y: 0}}
        transition={{duration: 0.5}}
        className="max-w-4xl mx-auto"
      >
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-slate-900 tracking-tight leading-tight text-balance mb-6">
          Most Happy Customers Never Leave Reviews. Get More Of Them — And Get Them Coming Back.
        </h1>
        <p className="text-lg md:text-xl text-slate-600 mb-10 max-w-2xl mx-auto text-balance">
          Turn every review request into an opportunity to promote your VIP club,loyalty program,special offers,and more.
        </p>

        {/* Livid Video Embed */}
        <div className="relative w-full max-w-3xl mx-auto bg-slate-100 rounded-2xl shadow-2xl overflow-hidden mb-10 border border-slate-200">
          <div style={{padding: '51.724% 0 0 0', position: 'relative', width: '100%'}}>
            <iframe
              style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%'}}
              allow="autoplay;clipboard-write;encrypted-media;fullscreen;picture-in-picture;web-share"
              allowFullScreen
              frameBorder="0"
              referrerPolicy="strict-origin-when-cross-origin"
              src="https://livid.com/embed/WOkMy_8Ejf59"
              title="RestoReviewgen"
            ></iframe>
          </div>
        </div>

        {/* Trial Offer */}
        <div className="bg-brand-50 border border-brand-100 rounded-xl p-4 md:p-6 mb-8 max-w-2xl mx-auto text-left">
          <p className="text-brand-900 font-medium text-sm md:text-base">
            <span className="text-yellow-500 mr-1 text-lg">⭐</span>
            Looking for a few restaurant owners to test this for 30 days. No credit card required. Continue for just $49/mo if it's a good fit for your restaurant.
          </p>
        </div>

        {/* Booking Section */}
        <div className="mb-8">
          <a
            style={{color: 'rgb(255,255,255)'}}
            href="https://meetings-na2.hubspot.com/geospaceweb/call"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block w-full sm:w-auto bg-brand-600 hover:bg-brand-700 text-white text-lg font-semibold py-4 px-8 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 transform hover:-translate-y-0.5 mb-6"
          >
            Choose a Time to Get Started
          </a>

          {/* Trust Strip */}
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm font-medium text-slate-600">
            {['No credit card required', '30-day free trial', 'Cancel anytime'].map((text, i) => (
              <div key={i} className="flex items-center gap-1.5">
                <div className="bg-green-100 rounded-full p-0.5">
                  <SafeIcon icon={FiCheck} className="w-3.5 h-3.5 text-green-600" strokeWidth={3} />
                </div>
                <span>{text}</span>
              </div>
            ))}
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;